import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import { FaLinkedinIn, FaGithub, FaHackerrank } from "react-icons/fa";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <>
      {/* ── Closing Sign-off Banner (Rendered above footer across all pages) ── */}
      <section className="footer-signoff-strip text-center">
        <Container>
          <p className="footer-signoff-text mb-0">
            Always exploring, always learning, ready to build reliable systems.
          </p>
        </Container>
      </section>

      <footer className="footer-pro">
        <Container>
          {/* Confidentiality Notice */}
          <Row className="mb-4">
            <Col md={12}>
              <div
                style={{
                  backgroundColor: "rgba(245, 181, 68, 0.04)",
                  border: "1px solid rgba(245, 181, 68, 0.2)",
                  borderRadius: "6px",
                  padding: "12px 18px",
                  fontSize: "0.88rem",
                  color: "#cbd5e1",
                  textAlign: "center",
                  lineHeight: "1.6",
                }}
              >
                Source code is not public because most of this work was built for clients under confidentiality. If you would like to know more about any project, email me at{" "}
                <a
                  href="mailto:earningfest@gmail.com"
                  style={{ color: "#F5B544", textDecoration: "underline" }}
                >
                  earningfest@gmail.com
                </a>.
              </div>
            </Col>
          </Row>

          <Row className="footer-top pb-4">
            {/* Main Brand Column */}
            <Col md={6} className="footer-brand-col text-start mb-4 mb-md-0">
              <h3 className="footer-brand mb-2">Sairitik Naidu</h3>
              <p className="footer-tagline">
                Full-stack and backend developer based in Nagpur. I build practical web tools,
                browser extensions, and reliable APIs.
              </p>
            </Col>

            {/* Navigation Column */}
            <Col md={3} sm={6} className="text-start mb-4 mb-md-0">
              <h6 className="footer-section-title">Navigation</h6>
              <ul className="footer-links-list">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About and Journey</Link></li>
                <li><Link to="/project">Projects</Link></li>
                <li><Link to="/resume">Resume</Link></li>
              </ul>
            </Col>

            {/* Contact Column */}
            <Col md={3} sm={6} className="text-start">
              <h6 className="footer-section-title">Direct Contact</h6>
              <ul className="footer-links-list">
                <li>
                  <a href="mailto:earningfest@gmail.com" className="d-flex align-items-center gap-2">
                    <AiOutlineMail /> earningfest@gmail.com
                  </a>
                </li>
              </ul>
              <div className="d-flex gap-2 mt-3">
                <a
                  href="https://github.com/Sairitik008"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon"
                  aria-label="GitHub profile"
                  title="GitHub Profile"
                >
                  <FaGithub />
                </a>
                <a
                  href="https://www.hackerrank.com/profile/sairitiknaidu7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon"
                  aria-label="HackerRank profile"
                  title="HackerRank Profile"
                >
                  <FaHackerrank />
                </a>
                <a
                  href="https://www.linkedin.com/in/sairitiknaidu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon"
                  aria-label="LinkedIn profile"
                  title="LinkedIn Profile"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </Col>
          </Row>

          <div className="footer-divider"></div>

          <div className="footer-bottom pt-3">
            <Row className="align-items-center">
              <Col md={6} className="text-start mb-2 mb-md-0">
                <p className="footer-copy">
                  © {year} Sairitik Naidu. Handcrafted with React and CSS.
                </p>
              </Col>
              <Col md={6} className="text-start text-md-end">
                <p className="footer-copy">
                  Nagpur, Maharashtra, India
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </footer>
    </>
  );
}

export default Footer;
